export type MaybePromise<T> = Promise<T> | T
export type Maybe<T> = NonNullable<T> | undefined
export type MaybeArray<T> = T | T[]
